module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/coursefinder-hero-91f0d5b9682fa17cfa1b3b6c06e4cf77.svg";